// 投資力診断の結果画面の「次へ」ボタン文言と遷移先。
// 通常の登録導線は投資スタイル診断へ進み、エキスポ会場の登録導線（Trello #241）は
// スタイル診断を飛ばしてプランナー紹介へ直接進む。
// 文言と遷移先はセットで切り替える（片方だけ変えると案内と実際の遷移がずれる）。
interface NextStep {
  label: string;
  path: string;
}

export const STYLE_DIAGNOSIS_NEXT_STEP: NextStep = {
  label: "次は投資スタイル診断へ進む",
  path: "/investment_style_diagnosis/intro",
};

export const EXPO_PLANNER_NEXT_STEP: NextStep = {
  label: "次はプランナーとマッチする",
  path: "/diagnosis_compatibility_agents/intro",
};

export const buildInvestmentDiagnosisNextStep = (expo: boolean): NextStep =>
  expo ? EXPO_PLANNER_NEXT_STEP : STYLE_DIAGNOSIS_NEXT_STEP;
